/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../../lib/State";
import log from "../../lib/log";
import pr from "../../lib/pr";
import CenterSelect from "../CenterSelect";
import MemberSearch from "../MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "../ProductSearch";
import { lightGreen } from "@mui/material/colors";
import get_token from "../../lib/get_token";
import { setDay } from "date-fns";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop, seq } = props;
  const token = get_token();
  const [tcid, setTcid] = useState("");
  const [data, setData] = useState({
    gubun: "",
    name: "",
    txtval: "",
    intval: 0,
    memo: "",
    use_yn: "N",
  });

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/board_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );
    if (result.data.success === 1) {
      setData({
        regdate: result.data.row.regdate,
        title: result.data.row.title,
        meta: result.data.row.meta,
        body: result.data.row.body,
      });
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };
  useEffect(() => {
    load_data();
  }, []);

  const delete_click = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/board_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  const submit_click = async () => {
    console.log(data);

    const postData = {
      ...data,
      tcid: tcid,
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      seq: seq,
    };

    let result = await axios.post(
      configState.api + "/gympass_admin/board_edit",
      postData
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  const update_data = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  return (
    <Box>
      <Box p={3} width="500px">
        <Box>
          <TextField
            defaultValue="등록일"
            name="regdate"
            label="등록일"
            size="small"
            fullWidth
            autoComplete="off"
            value={data.regdate}            
          ></TextField>
        </Box>

        <Box sx={{ mt: 1 }}>
          <TextField
            name="title"
            defaultValue="제목"
            label="제목"
            size="small"
            fullWidth
            autoComplete="off"
            value={data.title}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 문자 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            defaultValue="본문"
            name="body"
            label="본문"
            size="small"
            autoComplete="off"
            value={data.body}
            height="110px"
            fullWidth
            multiline
            rows={4}
            onChange={update_data}
          ></TextField>
        </Box>

        {/* 메타 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            defaultValue="메타"
            name="meta"
            label="메타"
            size="small"
            autoComplete="off"
            value={data.meta}
            height="110px"
            fullWidth
            multiline
            rows={4}
            onChange={update_data}
          ></TextField>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={submit_click} sx={{ mr: 1 }}>
            수정완료
          </Button>
          <Button variant="contained" onClick={delete_click} color="warning">
            삭제
          </Button>
          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
